import { makeStyles } from "@material-ui/core";

const useCircleCheckBoxStyles = makeStyles({
  checkbox: {
    position: "relative",
    height: "100%",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    color: "#4C5157",
    userSelect: "none",
    "& input": {
      /*  Hide the browser's default checkbox  */
      opacity: 0,
      cursor: "pointer",
      height: 0,
      width: 0,
      /* Show the checkmark when checked */
      "&:checked": {
        "& ~ $checkmark": {
          backgroundColor: "rgb(0,100,216)",
          "&:after": {
            display: "block",
          },
        },
      },
    },
    "& $checkmark": {
      "&:after": {
        left: "9px",
        top: "5px",
        width: "5px",
        height: "10px",
        border: "solid white",
        borderWidth: "0 3px 3px 0",
        transform: "rotate(45deg)",
      },
    },
  },

  checkmark: {
    display: "inline-block",
    marginInlineEnd: "10px",
    height: "22px",
    width: "22px",
    borderRadius: "26px",
    backgroundColor: "#fff",
    border: "1px solid #979797",
  },
});
export default useCircleCheckBoxStyles;
